module.exports = __webpack_public_path__ + "1b41138970104646931cf9772200e3fc.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/aircraft.svg
 ** module id = 529
 ** module chunks = 0
 **/